import React, {Component} from 'react';

import axios from 'axios';
import 'rc-steps/assets/index.css';
import Steps, { Step } from 'rc-steps';
import {SkyLightStateless} from 'react-skylight';

import urls from "../../../../utils/urls";
import {tokenHeader} from "../../../../utils/headers";
import {ajaxHandler} from "../../../../utils/errors";
import {Spinner} from "../../../../components/Loading/Spinner";
import helpers from '../../../../utils/helpers';
import ToggleInput from "../../../../components/ToggleInput/toggleInput";
import formatters from "../../../../utils/formatters";


export default class TripAudit extends Component {

    constructor(props){
        super(props);

        this.state = {
            showModal: false,
            trip: props.trip,
            logs: false,
            finished: true
        };
    }

    componentDidMount(){
        window.initializeTooltips();
    }
    _closeModal = () => {
        this.setState({showModal: false});
    };

    _openModal = () => {
        if(!this.state.logs){
            this._fetchLogs();
        }
        this.setState({showModal: true});
    };

    _fetchLogs = () => {
        const LOGS_URL = `${urls.API_ROOT}/api/v1/audit_logs/trip/${this.state.trip.id}/${this.state.finished ? '?finished=1' : ''}`;
        axios.get(LOGS_URL, tokenHeader())
            .then(response => {
                this.setState({
                    logs: response.data
                });
            })
            .catch(e => {
                this.setState({showModal: false});
                ajaxHandler(e);
            });
    };

    _handleToggle = () => {
        this.setState({
            finished: !this.state.finished,
            logs: false
        }, this._fetchLogs);
    };

    render() {
        let {showModal} = this.state;

        let modalStyle = {
            top: '10%',
            width: 600,
            height: 500,
            maxHeight: 400,
            marginTop: 0,
            marginLeft: -200,
            left: 'calc(50% - 100px)'
        };

        return (
            <div className={"log-component"}>
                <button className={"button-modal tooltipped"}
                        data-position={"bottom"} data-tooltip={"Ver auditoría"}
                        onClick={this._openModal}>
                    <img src={"/static/images/audit.png"} style={{width: 25}} alt={"Auditoría"} />
                </button>

                <div style={{position: 'absolute'}}>
                    <SkyLightStateless
                        onOverlayClicked={this._closeModal}
                        isVisible={showModal}
                        onCloseClicked={this._closeModal}
                        dialogStyles={modalStyle}
                        title={<h3 className="center" style={{fontSize: '18px', fontWeight: 'bold'}}>Auditoría</h3>}
                    >
                        {helpers.isUserSysadmin(this.props.user) &&
                        <ToggleInput
                            selected={!this.state.finished}
                            name={'¿Ver todos?'} stateVar={'finished'}
                            toggleAction={this._handleToggle}
                        />
                        }
                        <div className={"log-container"}>
                            {!this.state.logs &&
                                <div style={{height: '100%'}} className={"valign-wrapper"}>
                                    <Spinner />
                                </div>
                            }
                            {this.state.logs && this.state.finished &&
                            <Steps direction="vertical">
                                {this.state.logs.map((log, index) => {

                                    let timestamp = formatters.datetimeFormat(log.created_at);
                                    let user = `${log.user.first_name} ${log.user.last_name}`;
                                    let title = <span><span className={'log-stamp'}>{timestamp} - </span> <span>{user}</span></span>;

                                    let description = log.text;

                                    return (
                                        <Step key={index} title={title} description={description} />
                                    )
                                })}
                            </Steps>
                            }
                            {this.state.logs && !this.state.finished &&
                            <Steps direction="vertical">
                                {this.state.logs.map((log, index) => {

                                    let timestamp = formatters.datetimeFormat(log.created_at);
                                    let user = `${log.user.first_name} ${log.user.last_name}`;
                                    let title = <span><span className={'log-stamp'}>{timestamp} - </span> <span>{user}</span></span>;

                                    let description = JSON.stringify(log);

                                    return (
                                        <Step key={index} title={title} description={description} />
                                    )
                                })}
                            </Steps>
                            }
                        </div>
                    </SkyLightStateless>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/containers/Dashboard/Trips/Trip/TripAudit.js